import {Component} from "@angular/core";
import {MatDialogRef} from "@angular/material";

@Component({
  selector: 'corona-dialog',
  templateUrl: 'corona.component.html',
})
export class CoronaDialog {

  constructor(
    public dialogRef: MatDialogRef<CoronaDialog>) {}

  closeDialog(): void {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/home/corona.component.ts